import { AddressGouvFormDto } from './dtos/form/address-gouv-form.dto';
import { axiosCoreGouv } from './http-core-gouv.service';

/**
 * Appel API pour la récupération d'adresse via api gouv
 * @param address chaine de caractère
 */
export const getAddressGouv = async (address: string): Promise<AddressGouvFormDto> => {
    // Améliorer la recherche en gérant les tirets et espaces multiples
    const cleanedAddress = address
        .trimEnd()
        .replace(/\s+/g, '+') // Remplacer tous les espaces multiples par +
        .replace(/-/g, '+'); // Remplacer les tirets par + pour améliorer la recherche

    const response = await axiosCoreGouv.get('/search/?q=' + cleanedAddress + '&limit=15');
    return response.data;
};
